import { Component, DoCheck, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TableCellComponent } from '@captiveaire/table';
import { IDeviceStatusViewInfo } from '../shared/models/device-status-view-info.interface';
import { DeviceRecommendedActionComponent } from '../device-recommended-action/device-recommended-action.component';
import {DeviceStatusType} from '../shared/models/device-status-type.interface';
import { DeviceStatusViewInfoService } from '../shared/services/device-status-view-info.service';

@Component({
    selector: 'dl-device-status-cell',
    templateUrl: './device-status-cell.component.html',
    styleUrls: ['./device-status-cell.component.scss']
})
export class DeviceStatusCellComponent extends TableCellComponent implements DoCheck {
    public static $name: string = 'clDeviceStatusCell';

    @Input() public deviceStatusType: DeviceStatusType;
    @Input() public deviceCategory: string;
    @Input() public tooltipDirection: string = 'right';

    @Input() public hideRecommendedActions: boolean = false;
    @Input() public useAlternativeIcon: boolean = false;

    public state: IDeviceStatusViewInfo;

    private lastDeviceStatusType;

    constructor(
        private deviceStatusViewInfoService: DeviceStatusViewInfoService,
        private dialogService: MatDialog
    ) {
        super();
        this.setState();
    }

    public getIconStyle() {
        return {
            height: this.state.size + 'px',
            width: this.state.size + 'px'
        };
    }

    public ngDoCheck() {
        if (this.lastDeviceStatusType !== this.deviceStatusType) {
            this.setState();
            this.lastDeviceStatusType = this.deviceStatusType;
        }
    }

    public showRecommendedActionsPopup() {
        this.dialogService.open(DeviceRecommendedActionComponent, {
            data: {
                deviceStatusType: this.deviceStatusType,
                category: this.deviceCategory
            },
            disableClose: false
        });
    }

    public preventMisclicks($event) {
        $event.preventDefault();
        $event.stopPropagation();
    }

    private setState() {
        this.state = this.deviceStatusViewInfoService.getState(this.deviceStatusType, this.useAlternativeIcon);
    }
}
